import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import SeoForm from './forms/SeoForm';
import SeoFieldForm from './forms/SeoFieldForm';
import SeoList from './lists/SeoList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import Modal from "../layout/Modal";
import ModalEditor from "./ModalEditor";

class EmptyList extends React.Component {
    render() {
        return null;
    }
}

class FieldEditor extends React.Component {

    render() {
        return (
            <Fragment>
                <div className="col-md-12">
                    <div className="form-group">
                        <Button block={true} color="default" onClick={() => this.editor && this.editor.focus()} disabled={this.props.isLoading || !this.props.presets.component_id}>
                            Seo adatok <span className="caret"/>
                        </Button>
                    </div>
                </div>
                <ModalEditor ref={(editor) => this.editor = editor} {...this.props} />
            </Fragment>
        );
    }
}

class SeoEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        let List = this.props.list || Box;
        let Editor = this.props.editor || BoxEditor;
        let Form = SeoForm;
        const actionButtons = [<Button
            key="0"
            className="pull-right"
            disabled={!this.props.dirty || this.props.isLoading}
            color="primary"
            onClick={this.saveForm}
        >
            Mentés
        </Button>];
        if (this.props.presets.component_type) {
            Editor = FieldEditor;
            List = EmptyList;
        }
        List = <List
            {...this.props}
            collapsed={this.props.collapsed || false}
            theme="default"
            header={"Seo-k"}
            footer={[
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            ]}
        >
            <SeoList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
        </List>;
        Editor = <Editor
            {...this.props}
            ref={(editor) => this.editor = editor}
            theme="default"
            header="Seo"
            footer={actionButtons}
        >
            <Form {...this.props} />
        </Editor>;
        if (this.props.presets.component_type) {
            return <div className="row">
                {Editor}
                {List}
            </div>;
        } else {
            return <Fragment>
                {List}
                {Editor}
            </Fragment>;
        }
    }
}

export default createEditor({
    componentName: "Seo",
    WrappedComponent: SeoEditor,
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action, data, params};
        }
    }
});
